import { render, staticRenderFns } from "./editCargoStatusDialog.vue?vue&type=template&id=17ef125a&"
import script from "./editCargoStatusDialog.vue?vue&type=script&lang=js&"
export * from "./editCargoStatusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports